import { emperor } from '~/services';

export const fetchOneUserRequest = async (userId: string) => {
  return await emperor.get(`user/${userId}`, { params: { returnData: 'min' } });
};
